import { render } from "./list-cover-areas.vue?vue&type=template&id=1aba9c50&lang=html"
import script from "./list-cover-areas.vue?vue&type=script&lang=js"
export * from "./list-cover-areas.vue?vue&type=script&lang=js"

import "./list-cover-areas.vue?vue&type=style&index=0&id=1aba9c50&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__